// extracted by mini-css-extract-plugin
export default {"container":"contact_container__1fEUK","header":"contact_header__fqwuz","blocks":"contact_blocks__FSEd0"};